import { TermsAndConditionsModel } from "src/app/models/common/terms-and-conditions.model";

export interface ITradeQuoteModel {
  id?: string;
  lead: string;
  price: number;
  price_currency: string;
  storage_charge: number;
  storage_charge_currency: string;
  negotiation_percent: number;
  color_preference: string;
  min_manufacturing_year: number;
  max_manufacturing_year: number;
  pickup_ready_date: Date;
  purpose: string;
  condition: any;
  quote_valid_till: Date;
  remarks: string;
  request_number?: string;
  quantity: number;
  csc_revalidation_required: boolean;
  csc_revalidation_charge: number;
  csc_revalidation_charge_currency: string;
  terms_and_condition_fk: string | TermsAndConditionsModel;
  terms_and_condition_text: string;
  container_images: any;
  is_procurement: boolean;
}

export interface ITradeQuoteError {
  price: string[];
  price_currency: string[];
  storage_charge: string[];
  storage_charge_currency: string[];
  negotiation_percent: string[];
  color_preference: string[];
  min_manufacturing_year: string[];
  max_manufacturing_year: string[];
  pickup_ready_date: string[];
  purpose: string[];
  condition: string[];
  quote_valid_till: string[];
  remarks: string[];
  csc_revalidation_required: string[];
  csc_revalidation_charge: string[];
  csc_revalidation_charge_currency: string[];
  terms_and_condition_fk: string[];
  terms_and_condition_text: string[];
  container_images: string[];
}

export class TradeQuoteModel {
  id?: string;
  lead: string;
  price: number;
  price_currency: string;
  storage_charge: number;
  storage_charge_currency: string;
  negotiation_percent: number;
  color_preference: any;
  min_manufacturing_year: number;
  max_manufacturing_year: number;
  pickup_ready_date: Date;
  purpose: string;
  condition: any;
  quote_valid_till: Date;
  remarks: string;
  request_number: string;
  quantity: number;
  csc_revalidation_required: boolean;
  csc_revalidation_charge: number;
  csc_revalidation_charge_currency: string;
  terms_and_condition_fk: string | TermsAndConditionsModel;
  terms_and_condition_text: string;
  container_images: any;
  is_procurement: boolean;

  error: ITradeQuoteError;

  validations = {
    tentative_pickup_date: {
      minDate: new Date(),
    },
    negotiation_percent: {
      min: 0,
      max: 30,
    },
    max_manufacturing_year: {
      min: 1980,
      max: new Date().getFullYear(),
    },
    min_manufacturing_year: {
      min: 1980,
      max: new Date().getFullYear(),
    }
  }

  constructor(lead: string) {
    this.id = null;
    this.lead = lead;
    this.price = null;
    this.price_currency = 'USD';
    this.storage_charge = null;
    this.storage_charge_currency = 'USD';
    this.negotiation_percent = 10;
    this.color_preference = null;
    this.min_manufacturing_year = 2005;
    this.max_manufacturing_year = 2023;
    this.pickup_ready_date = null;
    this.purpose = 'export';
    this.condition = null;
    let quote_valid_till = new Date();
    quote_valid_till.setDate(quote_valid_till.getDate() + 21);
    this.quote_valid_till = quote_valid_till;
    this.remarks = null;
    this.request_number = null;
    this.quantity = null;
    this.csc_revalidation_required = true;
    this.csc_revalidation_charge = null;
    this.csc_revalidation_charge_currency = 'USD';

    this.terms_and_condition_fk = null;
    this.terms_and_condition_text = null;
    this.container_images = null;
    this.is_procurement = false;

    this.resetErrors();
  }

  // add days to date


  resetErrors() {
    this.error = {
      price: [],
      price_currency: [],
      storage_charge: [],
      storage_charge_currency: [],
      negotiation_percent: [],
      color_preference: [],
      min_manufacturing_year: [],
      max_manufacturing_year: [],
      pickup_ready_date: [],
      purpose: [],
      condition: [],
      quote_valid_till: [],
      remarks: [],
      csc_revalidation_required: [],
      csc_revalidation_charge: [],
      csc_revalidation_charge_currency: [],
      terms_and_condition_fk: [],
      terms_and_condition_text: [],
      container_images: [],
    }
  }

  is_valid() {
    this.resetErrors();

    if (this.quote_valid_till == null) {
      this.error.quote_valid_till.push('Please select quotation validity date');
    }
    if (this.price == null) {
      this.error.price.push('Price is required');
    }
    if (this.storage_charge == null) {
      this.error.storage_charge.push('Storage charge is required');
    }
    if (this.condition == null) {
      this.error.condition.push('Please select condition of container');
    }

    return this.error.price.length == 0 &&
      this.error.storage_charge.length == 0 &&
      this.error.condition.length == 0 &&
      this.error.quote_valid_till.length == 0
  }

  getSavePayload(): ITradeQuoteModel {
    return {
      lead: this.lead,
      price: this.price,
      price_currency: this.price_currency,
      storage_charge: this.storage_charge,
      storage_charge_currency: this.storage_charge_currency,
      negotiation_percent: this.negotiation_percent,
      color_preference: typeof this.color_preference == 'object' && this.color_preference != null ? this.color_preference.id : this.color_preference,
      min_manufacturing_year: this.min_manufacturing_year,
      max_manufacturing_year: this.max_manufacturing_year,
      pickup_ready_date: this.pickup_ready_date,
      purpose: this.purpose,
      condition: typeof this.condition == 'object' && this.condition != null ? this.condition.id : this.condition,
      quote_valid_till: this.quote_valid_till,
      remarks: this.remarks,
      quantity: this.quantity,
      csc_revalidation_required: this.csc_revalidation_required,
      csc_revalidation_charge: this.csc_revalidation_required ? null : this.csc_revalidation_charge,
      csc_revalidation_charge_currency: this.csc_revalidation_charge_currency,
      terms_and_condition_fk: typeof this.terms_and_condition_fk == 'object' && this.terms_and_condition_fk != null ? this.terms_and_condition_fk.id : this.terms_and_condition_fk,
      terms_and_condition_text: this.terms_and_condition_text,
      container_images: this.container_images,
      is_procurement: this.is_procurement,

    }
  }

  savePayloadToModel(payload: ITradeQuoteModel) {
    this.id = payload.id;
    this.lead = payload.lead;
    this.price = payload.price;
    this.price_currency = payload.price_currency;
    this.storage_charge = payload.storage_charge;
    this.storage_charge_currency = payload.storage_charge_currency;
    this.negotiation_percent = payload.negotiation_percent;
    this.color_preference = payload.color_preference;
    this.min_manufacturing_year = payload.min_manufacturing_year;
    this.max_manufacturing_year = payload.max_manufacturing_year;
    this.pickup_ready_date = payload.pickup_ready_date;
    this.purpose = payload.purpose;
    this.condition = payload.condition;
    this.quote_valid_till = payload.quote_valid_till;
    this.remarks = payload.remarks;
    this.request_number = payload.request_number;
    this.csc_revalidation_required = payload.csc_revalidation_required;
    this.csc_revalidation_charge = payload.csc_revalidation_charge;
    this.csc_revalidation_charge_currency = payload.csc_revalidation_charge_currency;
    this.terms_and_condition_fk = payload.terms_and_condition_fk;
    this.terms_and_condition_text = payload.terms_and_condition_text;
    this.container_images = this.container_images.map((item) => item.id);
    this.is_procurement = payload.is_procurement;

  }


}
